module.exports = __webpack_public_path__ + "assets/img/71f25a71544c580df6e237c66c42263b.png";